import { IsEmail, IsNotEmpty } from "class-validator";

export class OrganizationDTO {
  @IsNotEmpty({ message: 'L\'email est requis' })
  @IsEmail(undefined, { message: 'Le format de l\'email est incorrect' })
  email: string;

}